import { mapOptions, resetMapBtn } from '../options';

/**
 * Check if map has been moved away from center or zoomed away from the default
 * zoom level
 *
 * @param {*} map
 */
export function checkMap(map) {
    let moved;
    let zoomed;

    const currentCenter = map.getCenter();
    const currentZoom = map.getZoom();

    currentCenter.lat !== mapOptions.center[0] ||
    currentCenter.lng !== mapOptions.center[1]
        ? (moved = true)
        : (moved = false);

    currentZoom !== mapOptions.zoom ? (zoomed = true) : (zoomed = false);

    moved || zoomed
        ? (resetMapBtn.disabled = false)
        : (resetMapBtn.disabled = true);
}
